
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/officecubiclequotes",
      function () {
        return require("private-next-pages/officecubiclequotes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/officecubiclequotes"])
      });
    }
  